<form [ngClass]="{'isHidden': uploading}" [formGroup]="fg">
    <h2 class="text-center">Rediger udstyr</h2>
    <div *ngIf="wrongInput" class="alert alert-danger">
        {{wrongInputReason}}
    </div>
    <p>
        {{guideText}}
    </p>
    <div class="form-group">
        <label>Vælg evt nyt billede af udstyr - eksisterende billede slettes</label>
        <input type="file" class="form-control-file" (change)="handleFileInput($event.target.files)">
    </div>
    <div class="form-group">
        <label>Kategori</label>
        <select class="form-control form-control-sm" formControlName="category_id" placeholder="Vælg kategori">
            <option *ngFor="let cat of categories" [value]="cat['id']">{{cat['name']}}</option>
        </select>
    </div>
    <hr>
    <div class="form-group">
        <label>Betegnelse</label>
        <input formControlName="betegnelse" type="text" class="form-control form-control-sm" placeholder="Indtast betegnelse">
    </div>
    <div class="form-group">
        <label>Placering</label>
        <textarea formControlName="placering" class="form-control form-control-sm" rows="4" placeholder="Indtast adresse"></textarea>
    </div>
    <div class="form-group">
        <label>Postnr</label>
        <input formControlName="postnr" type="text" class="form-control form-control-sm" placeholder="Indtast postnr">
    </div>
    <div class="form-group">
        <label>Minimums frist (antal dage der skal reserveres forinden)</label>
        <input formControlName="minimumsFrist" type="text" class="form-control form-control-sm" placeholder="Indtast minimums frist">
    </div>
    <div class="form-group">
        <label>Særligt</label>
        <textarea formControlName="saerligt" class="form-control form-control-sm" rows="4" placeholder="Indtast særlig info vedr. udstyr"></textarea>
    </div>
    <div class="form-group">
        <label>Ejernavn</label>
        <input formControlName="ejernavn" type="text" class="form-control form-control-sm" placeholder="Indtast ejernavn">
    </div>
    <hr>
    <h4>Kontaktperson</h4>
    <div class="form-group">
        <label>Navn</label>
        <input formControlName="kpNavn" type="text" class="form-control form-control-sm" placeholder="Indtast navn">
    </div>
    <div class="form-row">
        <div class="form-group col-md-6">
            <label>Email</label>
            <input formControlName="kpEmail" type="text" class="form-control form-control-sm" placeholder="Indtast email">
        </div>
        <div class="form-group col-md-6">
            <label>Telefon</label>
            <input formControlName="kpTlf" type="text" class="form-control form-control-sm" placeholder="Indtast tlf. nr">
        </div>
    </div>

    <div class="form-group float-right">
        <button class="btn btn-warning" [mat-dialog-close]="false">Annuller</button>
        <button type="submit" class="btn btn-primary" (click)="doSubmit()">Rediger</button>
    </div>
</form>
<div [ngClass]="{'isHidden': !uploading}">
    
    <mat-spinner style="margin: 75px auto;"></mat-spinner>
</div>